var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card uptime-card" }, [
    _c("div", { staticClass: "uptime-details" }, [
      _c("div", { staticClass: "uptime-text" }, [
        _c("span", [
          _c("strong", [_vm._v("Uptime: ")]),
          _vm._v(_vm._s(100 - _vm.downtime.percent) + "%")
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("  ")]),
        _vm._v(" "),
        _c("span", [
          _c("strong", [_vm._v("Total Time: ")]),
          _vm._v(_vm._s(_vm.friendlyDuration(_vm.downtime.total)))
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("  ")]),
        _vm._v(" "),
        _c("span", [
          _c("strong", [_vm._v("MTTA: ")]),
          _vm._v(_vm._s(_vm.friendlyDuration(_vm.mean(_vm.alerts, "ackTime"))))
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("  ")]),
        _vm._v(" "),
        _c("span", [
          _c("strong", [_vm._v("MTTC: ")]),
          _vm._v(
            _vm._s(_vm.friendlyDuration(_vm.mean(_vm.alerts, "closeTime")))
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "uptime-bar" }, [
      _c("div", {
        staticClass: "uptime-bar-green",
        style: { width: 100 - _vm.downtime.percent + "%" }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "uptime-bar-red",
        style: { width: _vm.downtime.percent + "%" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81a07b00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81a07b00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alerts/Uptime.vue
// module id = null
// module chunks = 